var _rect, _path, _path2, _circle, _path3, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiStudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "black",
    strokeWidth: 1.5,
    fill: "#F0F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13H4.5L6.5 6.5H7.5L9.5 13H8.5L7 8.3H7L5.5 13ZM5.7 10.5H8.3V11.2H5.7V10.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.5V13H10V6.5H11Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 4.5,
    r: 3,
    fill: "#FFD700",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3L15.8 4L16.8 4.3L15.8 4.6L15.5 5.5L15.2 4.6L14.2 4.3L15.2 4L15.5 3Z",
    fill: "black"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 2,
    y: 18,
    fontFamily: "Arial, sans-serif",
    fontSize: 3,
    fontWeight: "bold",
    fill: "#333"
  }, "STUDIO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStudio);
export default __webpack_public_path__ + "static/media/ai-studio.1ee6469e1294eba994a097b93bd8efea.svg";
export { ForwardRef as ReactComponent };